import { gql } from '@apollo/client';

const GUEST_FRAGMENT = gql`
  fragment GuestFragment on Guest {
    id
    firstName
    lastName
    fullName
    email
    unconfirmedEmail
    confirmed
    phone
    gravatarUrl
    address {
      id
      streetAddress1
      streetAddress2
      city
      state
      zip
      country
      formattedAddress
    }
  }
`;
export const GET_CURRENT_GUEST = gql`
  query GetCurrentGuest {
    authenticatedGuest {
      ...GuestFragment
    }
  }
  ${GUEST_FRAGMENT}
`;

export const UPDATE_GUEST = gql`
  mutation UpdateGuest($input: UpdateCurrentGuestInput!) {
    updateCurrentGuest(input: $input) {
      guest {
        ...GuestFragment
      }
    }
  }
  ${GUEST_FRAGMENT}
`;
